import React, { useEffect, useRef } from "react";
import Lottie from "lottie-react";
import menuIconAnimation from "./../../../lottie/menu-icon.json";

// Edited with https://edit.lottiefiles.com/?src=https%3A%2F%2Fassets2.lottiefiles.com%2Fpackages%2Flf20_0nrpcgb7.json
import menuIconAnimationBright from "./../../../lottie/menu-icon-bright.json";

import styled from 'styled-components';

const MenuIcon = ({menuOpen, onOpen, isBright}) => {
    const lottieRef = useRef();
  
    const onComplete = () => {
      
    }
  
    useEffect(() => {
      let direction = menuOpen ? 1 : -1;
      lottieRef.current.setDirection(direction)
      //lottieRef.current.setSpeed(1.5)
      lottieRef.current.play()
    }, [menuOpen]);
  
    const onIconClick = () => {
      onOpen();
    }
  
    return <span onClick={() => onIconClick()}>
      <Lottie 
        animationData={isBright ? menuIconAnimationBright : menuIconAnimation}
        loop={false}
        autoplay={false}
        style={{
          width: '1.5em',
          height: '1.5em',
        }}
        lottieRef={lottieRef}
        onComplete={() => onComplete()}
      />
      </span>
    ;
  };

  export default MenuIcon;